module.exports = __webpack_public_path__ + "img/features04-04.e88db5c.png";